exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mat-raised-button {\r\n    margin: 20%\r\n}\r\n\r\n.confirmation-message {\r\n    margin-left: 20%;\r\n    margin-right: 20%;\r\n}\r\n\r\n.cancel-button {\r\n    background-color: #c9c9c9;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();